import { ɵɵdefineInjectable, ɵɵinject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of, BehaviorSubject } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
class AccessRequestsModuleConfigService {
    constructor(http) {
        this.http = http;
        this.noAccessPageUrl = '/access-requests/no-access-page';
    }
    /**
     * Used to determine if Access Requests is enabled in the current system.
     * Can be accessed by many different packages such as AccessRequestsModule,
     * NavModule, and AuthModule.
     */
    get accessRequestsEnabled() {
        // if we already have the answer, just return it
        if (this._accessRequestsEnabled) {
            return this._accessRequestsEnabled.asObservable();
        }
        // otherwise set it up for next time
        return this.setupAccessRequestsEnabled();
    }
    /**
     * Checks with the BackEnd to determine whether AccessRequests are enabled
     * and stores that value for next time in _accessRequestsEnabled
     */
    setupAccessRequestsEnabled() {
        // using a get call to /access-requests/check-enabled to determine if it is enabled
        return this.http.get('/access-requests/check-enabled').pipe(map(() => true), catchError((error) => {
            if (error && error.status === 404) {
                return of(false);
            }
            else {
                return of(true);
            }
        }), tap((value) => (this._accessRequestsEnabled = new BehaviorSubject(value))));
    }
}
AccessRequestsModuleConfigService.ɵfac = function AccessRequestsModuleConfigService_Factory(t) { return new (t || AccessRequestsModuleConfigService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient)); };
AccessRequestsModuleConfigService.ɵprov = ɵɵdefineInjectable({ factory: function AccessRequestsModuleConfigService_Factory() { return new AccessRequestsModuleConfigService(ɵɵinject(HttpClient)); }, token: AccessRequestsModuleConfigService, providedIn: "root" });
AccessRequestsModuleConfigService.ctorParameters = () => [
    { type: HttpClient }
];
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(AccessRequestsModuleConfigService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }]; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { AccessRequestsModuleConfigService };


//# sourceMappingURL=mt-ng2-access-requests-module-config.js.map